/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ScholarshiptypeDropdown200,
  GetApiV1ScholarshiptypeDropdown401,
  GetApiV1ScholarshiptypeDropdown500,
  GetApiV1ScholarshiptypeDropdownQueryParams,
  GetApiV1ScholarshiptypeDropdownQueryResponse,
} from "../../types/scholarshipTypeRegistroController/GetApiV1ScholarshiptypeDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1ScholarshiptypeDropdownQueryParamsSchema = z
  .object({
    companyId: z.optional(z.coerce.number().int()),
    scholarshipTypeId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ScholarshiptypeDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ScholarshiptypeDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1ScholarshiptypeDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ScholarshiptypeDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ScholarshiptypeDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeDropdown500>;

export const getApiV1ScholarshiptypeDropdownQueryResponseSchema = z.lazy(
  () => getApiV1ScholarshiptypeDropdown200Schema,
) as unknown as ToZod<GetApiV1ScholarshiptypeDropdownQueryResponse>;
